// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "1e7f1a3b6f0fda07f7ea486ca95df1d5" + ".js";
};